import React from "react";
import "../css/loading_screen.css";

export default function LoadingScreen() {
  return (
    <div className="loading-page">
      <div className="stuff-container">
        <h1>Načítám vaše data :)</h1>
        <img src="/img/loading.gif" alt="loading..."></img>
      </div>
    </div>
  );
}
